import React from 'react';
import LicensesWrapper from './Licenses.styles';

import LicensesListItem from './LicenseListItem';

import { localization } from '../localization';
import { LanguageKeys, LicenseItem } from '../CommonTypes';

const extractNameFromGithubUrl = (url: string) => {
  if (!url) {
    return null;
  }

  const reg = /((https?:\/\/)?(www\.)?github\.com\/)?(@|#!\/)?([A-Za-z0-9_]{1,15})(\/([-a-z]{1,20}))?/i;
  const components = reg.exec(url);

  if (components && components.length > 5) {
    return components[5];
  }
  return null;
};

function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const generateLicenseList = (licenses: [string, LicenseItem][]) => {
  let licenseObject = licenses.map(([key, { licenses, repository, licenseUrl }]) => {
    let [name, version] = key.split('/').pop()!.split('@');

    let username =
      extractNameFromGithubUrl(repository) ||
      extractNameFromGithubUrl(licenseUrl);
  
    if (username) {
      username = capitalizeFirstLetter(username);
    }

    return {
      key,
      name,
      username,
      licenses: licenses.slice(0, 405),
      version,
      repository,
      licenseUrl
    };
  });

  licenseObject.sort((a, b) => {
    if (a.username === null)
      return b.username === null ? 0 : -1;
    if (b.username === null)
      return 1;
    return a.username > b.username ? 1 : b.username > a.username ? -1 : 0;
  });
  return licenseObject;
};

export type LicenseList = ReturnType<typeof generateLicenseList>;
export type LicenseListItem = LicenseList[number];

export interface LicensesProps {
  licenses: LicenseList;
  lang: LanguageKeys;
  
  openLink: (link: string, newTab: boolean) => void;
}

export const Licenses: React.FC<LicensesProps> = ({ licenses, lang, openLink }) => (
  <LicensesWrapper>
    <p id='LicensesTitle'>{ localization[lang].usedLibs }</p>
    {
      licenses.map(license => <LicensesListItem key={license.key} item={license} lang={lang} openLink={openLink} />)
    }
    <LicensesListItem item={{
      key: "",
      name: "Googole Fonts: Roboto",
      username: null,
      licenses: "Apache License, version 2.0",
      version: "latin regular",
      repository: "https://fonts.google.com/attribution",
      licenseUrl: "http://www.apache.org/licenses/LICENSE-2.0.html"
    }} lang={lang} openLink={openLink} />
  </LicensesWrapper>
);

export default Licenses;
